import { ModelBase, Property, Required, ShortString } from '@skylab-shared/core';
import { BankAccountStatus } from './../bank-account/bank-account-status';


export class ClientBankAccountModel extends ModelBase {
    @Property()
    public default: boolean;

    @Property()
    @ShortString('data-model.client.validation.bank-name.length')
    public bankName: string;

    @Property()
    @ShortString('data-model.client.validation.bank-account-number.length')
    @Required('data-model.client.validation.bank-account-number.non-empty')
    public number: string;

    @Property()
    public status: BankAccountStatus;

    @Property({ nullable: true })
    public statusDate: Date;

    @Property({ nullable: true })
    public statusId: string;

}
